/**
 * Filter rendered shop cards using Liquid-rendered vendor and collection data.
 * sf-collection and sf-vendor stack with AND logic; no API requests are needed.
 */
(function () {
  'use strict';

  if (window.shopFilters) {
    window.shopFilters.apply();
    return;
  }

  const P_COL = 'sf-collection';
  const P_VEN = 'sf-vendor';

  class ShopFilters {
    constructor() {
      this.originalCounts = new WeakMap();
      document.addEventListener('click', (event) => this.onClick(event));
      window.addEventListener('popstate', () => this.apply());
      document.addEventListener('facets:change', () => this.apply());
      document.addEventListener('shopify:section:load', () => this.apply());
      document.addEventListener('DOMContentLoaded', () => this.apply());
    }

    state() {
      const params = new URLSearchParams(window.location.search);
      return {
        col: params.get(P_COL) || '',
        vendor: params.get(P_VEN) || '',
      };
    }

    onClick(event) {
      const pill = event.target.closest('[data-filter-type][data-filter-value]');
      if (!pill || !pill.closest('.shop-filters')) return;

      const type = pill.dataset.filterType;
      if (type !== 'collection' && type !== 'vendor') return;
      const value = pill.dataset.filterValue;
      const state = this.state();
      const current = type === 'collection' ? state.col : state.vendor;
      const next = value.toLowerCase() === current.toLowerCase() ? '' : value;
      const params = new URLSearchParams(window.location.search);
      const param = type === 'collection' ? P_COL : P_VEN;
      next ? params.set(param, next) : params.delete(param);

      const searchParams = params.toString();
      // Match the state shape used by the theme's native facet history handler.
      history.pushState(
        { searchParams },
        '',
        window.location.pathname + (searchParams ? '?' + searchParams : '') + window.location.hash,
      );
      this.apply();
    }

    apply() {
      if (!document.querySelector('.shop-filters')) return;
      const { col, vendor } = this.state();
      const active = Boolean(col || vendor);
      const vendorLower = vendor.toLowerCase();

      document.querySelectorAll('.shop-filters [data-filter-type][data-filter-value]').forEach((pill) => {
        const selected = pill.dataset.filterType === 'collection' ? col : vendor;
        const on = pill.dataset.filterValue.toLowerCase() === selected.toLowerCase();
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-pressed', String(on));
      });

      const grid = document.getElementById('product-grid');
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('.collection__grid__item[data-product-id]'));
      let visible = 0;
      cards.forEach((card) => {
        let collections = [];
        try {
          collections = JSON.parse(card.dataset.sfCollections || '[]');
        } catch (error) {
          console.warn('Invalid shop card collection data', error);
        }
        const colMatch = !col || col === 'all' || collections.includes(col);
        const vendorMatch = !vendor || card.dataset.sfVendor === vendorLower;
        const show = colMatch && vendorMatch;
        card.classList.toggle('sf-hidden', !show);
        if (show) {
          visible++;
          card.style.setProperty('--animation-order', String(visible));
        }
      });

      const container = document.getElementById('ProductGridContainer');
      container?.querySelectorAll('[data-shop-product-count]').forEach((counter) => {
        if (!this.originalCounts.has(counter)) this.originalCounts.set(counter, counter.textContent);
        const label = visible === 1 ? grid.dataset.shopCountOne : grid.dataset.shopCountOther;
        counter.textContent = active
          ? label.replace('[count]', String(visible))
          : this.originalCounts.get(counter);
      });

      let empty = document.getElementById('sf-empty');
      if (!empty) {
        empty = document.createElement('p');
        empty.id = 'sf-empty';
        empty.className = 'sf-empty-msg';
        empty.setAttribute('role', 'status');
        empty.textContent = grid.dataset.shopEmptyText;
        grid.insertAdjacentElement('afterend', empty);
      }
      empty.hidden = !active || visible > 0 || cards.length === 0;

      // Promotional grid cards must not appear as product filter results.
      grid.querySelectorAll(':scope > :not([data-product-id])').forEach((item) => {
        item.classList.toggle('sf-hidden', active);
      });
      document.documentElement.classList.remove('shop-filter-pending');
    }
  }

  window.shopFilters = new ShopFilters();
  window.shopFilters.apply();
})();
